export default __webpack_public_path__ + "static/media/minusDisabled.d80c52ad.svg";